import { colors } from "@mui/material";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: `linear-gradient( 
        136deg, ${theme.palette.secondary.light} 0%, 
        ${theme.palette.secondary.main} 50%,
        ${theme.palette.secondary.dark} 100%)`,
    },
  },
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: `linear-gradient( 
        136deg, ${theme.palette.success.light} 0%, 
        ${theme.palette.success.main} 50%,
        ${theme.palette.success.dark} 100%)`,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    backgroundColor: colors.grey[300],
    border: 0,
    borderRadius: 1,
    height: 3,
  },
}));

const ColorlibStepIconRoot = styled("div")<{
  ownerState: { hasBeenCompleted: boolean; isActive: boolean; isCompleted: boolean };
}>(({ ownerState, theme }) => ({
  alignItems: "center",
  backgroundColor: colors.grey[400],
  borderRadius: "50%",
  color: "#fff",
  display: "flex",
  height: 48,
  justifyContent: "center",
  [theme.breakpoints.up("md")]: {
    height: 48,
    width: 48,
  },
  [theme.breakpoints.up("xs")]: {
    height: 40,
    width: 40,
  },
  width: 48,
  zIndex: 1,
  ...(ownerState.isActive && {
    backgroundImage: `linear-gradient( 
        136deg, ${theme.palette.secondary.light} 0%, 
        ${theme.palette.secondary.main} 50%,
        ${theme.palette.secondary.dark} 100%)`,
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.isCompleted && {
    backgroundImage: `linear-gradient( 
        136deg, ${theme.palette.success.light} 0%, 
        ${theme.palette.success.main} 50%,
        ${theme.palette.success.dark} 100%)`,
  }),
  ...(ownerState.hasBeenCompleted && {
    "&:hover": {
      backgroundColor: theme.palette.success.main,
    },
    border: `1px solid ${theme.palette.success.main}`,
    cursor: "pointer",
    transition: "background-color 0.1s ease-in-out",
  }),
}));

export { ColorlibConnector, ColorlibStepIconRoot };
